import React from 'react';
import Connected from '../../../connected';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { disposeOnUnmount } from 'mobx-react';
import { reaction } from 'mobx';
import { transformOfRotateAndFlip } from '../../../common';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ElementsAnalyze } from '@src/slide/domain/ui-model/element-modeles/elements-analysis';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

interface Props {
    scale: number;
}

export default class ConnectedElements extends React.Component<Props> {
    protected elements: IElementBaseModel[]|null;
    public constructor(props: Props) {
        super(props);
        this.elements = this.canBeConnectedElements();
    }

    public componentDidMount() {
        disposeOnUnmount(
            this,
            reaction(
                // 连接态以及slide的切换均需重刷吸附点
                () => [this.getEditingStateManager().isConnecting,
                    this.getSelectionService()?.currentSlide],
                () => {
                    this.elements = this.canBeConnectedElements();
                    this.setState({});
                },
            ),
        );
    }

    public render() {
        if (this.getEditingStateManager().isConnecting && this.elements?.length) {
            return (
                <React.Fragment>
                    {this.elements.map(this.renderCanBeConnectedElement)}
                </React.Fragment>);
        }
        return null;
    }

    protected canBeConnectedElements = () => {
        if (!this.getSelectionService()?.currentSlide) {
            return null;
        }
        const currentSlideModel = this.getSelectionService()?.currentSlide;
        const validTypes = [UIModelType.TABLE, UIModelType.IMAGE, UIModelType.SHAPE];
        return ElementsAnalyze.getTypesOfElements(currentSlideModel?.children, validTypes)
            .filter(elementModel => elementModel.selectable
                && elementModel.currentEditState === PPTEditorStateType.EDITABLE);
    };

    protected getSelectionService() {
        return ((AppServiceProvider.getInstance().getAppServices() as IEditorAppServices))
            .viewableServiceLayer?.selectionService;
    }

    protected getEditingStateManager() {
        return ((AppServiceProvider.getInstance().getAppServices() as IEditorAppServices))
            .viewableServiceLayer.editingStateManager;
    }

    protected renderCanBeConnectedElement = (element: IElementBaseModel) => {
        const elementModel = element;
        const frameOnSlide = elementModel.getFrame?.().frameOnSlide();
        return (
            <div
                key={element.id}
                style={{
                    ...(frameOnSlide as React.CSSProperties),
                    position: 'absolute',
                    pointerEvents: 'none',
                    transform: transformOfRotateAndFlip(frameOnSlide),
                }}
            >
                <Connected
                    styleModel={elementModel.props.style}
                    component={elementModel}
                    scale={this.props.scale}
                    pathParser={elementModel.pathParser}
                    editingStateManager={this.getEditingStateManager()}
                >
                </Connected>
            </div>
        );
    };
}
